import asideNavBar from "../components/asideNavBar";
import burgerButtonRendering from "../components/burgerButton";
import createNewProductButton from "../components/newProductButton";
import footerRendering from "../components/footer";
import headerRendering from "../components/header";
import PrivilegeEnum from "../enums/PrivilegeEnum";
import StoreUser from "../entities/StoreUser";
export function commonComponentsRendering(store, commonComponents) {
    commonComponents.header.innerHTML = headerRendering(store);
    commonComponents.footer.innerHTML = footerRendering();
    commonComponents.asideNavBarContainer.innerHTML = asideNavBar(store);
    sideNavRendering(store);
    searchBarEvent();
    burgerButtonRendering(commonComponents);
}
function sideNavRendering(store) {
    var navBarContainer = document.getElementById("nav-bar-container");
    if (store.user instanceof StoreUser) {
        if (store.user.privilege === PrivilegeEnum.admin) {
            var newProductLink = createNewProductButton();
            navBarContainer.appendChild(newProductLink);
        }
    }
}
function searchBarEvent() {
    var searchButton = document.getElementById("nav-search-button");
    var searchInput = document.getElementById("nav-search-input");
    searchButton.addEventListener("click", function (event) {
        event.preventDefault();
        window.location.hash = "#/productList?search=" + searchInput.value;
    });
}
